export default "__VITE_ASSET__DPRBM1jJ__"